module.exports = __webpack_public_path__ + "static/media/icon-title-alert.769ac45c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Comfirmapprove/assets/icon-title-alert.svg
// module id = 1939
// module chunks = 193